import { FC, useEffect, useState } from 'react';
import { Slider } from 'antd';
import { TbInfoCircle } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { useEntitlements } from '@/hooks/useEntitlements';
import { PlanTag } from '@/shared';
import { PlatformAlert } from '@/shared/components/alerts';

interface InstitutionalOwnershipProps {
    filters: any;
    handleChange: any;
}

const InstitutionalOwnership: FC<InstitutionalOwnershipProps> = ({ filters, handleChange }): JSX.Element => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);

    const { hasMinimumPlan } = useEntitlements();

    const ranksArray = ['0% - 9%', '10% - 19%', '20% - 29%', '30% - 39%', '40% - 49%'];

    const { token } = useAntDesignTheme();

    return !hasMinimumPlan('plus') ? (
        <div style={{ textAlign: 'center', margin: '2rem' }}>
            <PlanTag plan={'plus'} style={{ marginLeft: '0.5rem' }} />
        </div>
    ) : (
        <>
            <PlatformAlert
                title='Ownership percentage'
                showIcon
                status='info'
                icon={
                    <TbInfoCircle
                        size='1.125rem'
                        style={{
                            marginRight: '0.75rem',
                            marginTop: '0.1rem',
                        }}
                    />
                }
                description={<span>Represents the ownership as a percentage (%) of total shares outstanding.</span>}
                style={{ marginBottom: '0.75rem' }}
            />
            <small style={{ color: token.colorTextTertiary }}>Ownership (%)</small>
            <div style={{ marginTop: '0.5rem' }}>
                <Slider
                    range
                    value={[filters?.institutionalOwnership?.min, filters?.institutionalOwnership?.max]}
                    onChange={(values) =>
                        handleChange(['institutionalOwnership'], {
                            min: values[0],
                            max: values[1],
                        })
                    }
                    max={100}
                    min={0}
                    step={1}
                />
            </div>
        </>
    );
};

export default InstitutionalOwnership;
